"use client"

// src/components/separator.ts
var Separator = {
  baseStyle: {
    borderColor: "border"
  },
  variants: {
    dashed: {
      borderStyle: "dashed"
    },
    dotted: {
      borderStyle: "dotted"
    },
    solid: {
      borderStyle: "solid"
    }
  },
  defaultProps: { variant: "solid" }
};

export {
  Separator
};
//# sourceMappingURL=chunk-LJS7JJGY.mjs.map